import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getMarketingDataFromUrl } from '../../lib/side-effects';
import { setActiveFlow } from '../../store/system';
import ContactSales from './contact-sales';
import SubscriptionDetails from './subscription-details';
import TrialBanner from './trial-banner';

import type { Dispatch } from '@avalara/types/actions';

const FreeTrial = () => {
  const dispatch = useDispatch<Dispatch>();

  useEffect(() => {
    dispatch(setActiveFlow('trial-extension'));
    dispatch(getMarketingDataFromUrl());
  }, []);

  return (
    <div>
      <TrialBanner secondLineText='Avalara AvaTax API trial' />
      <SubscriptionDetails />
      <ContactSales />
    </div>
  );
};

export default FreeTrial;
